import { render } from "./PublicationItem.vue?vue&type=template&id=14d14804"
import script from "./PublicationItem.vue?vue&type=script&lang=js"
export * from "./PublicationItem.vue?vue&type=script&lang=js"
script.render = render

export default script